import { QueryResult } from '@apollo/client'
import { GetEjTypesQuery, useGetEjTypesQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

type GetEjTypesQueryResult = QueryResult<GetEjTypesQuery>
export type EJType = GetEjTypesQuery['ejTypes']['records'][0]

const { Provider, useContextFn } = createStrictContext<{
  records: EJType[]
  refetch: GetEjTypesQueryResult['refetch']
  fetching: GetEjTypesQueryResult['loading']
}>('TypesTableContext')

export const useTypesTableContext = useContextFn

export const TypesTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    refetch,
    loading: fetching,
  } = useGetEjTypesQuery({
    ...DefaultQueryHookOptions,
    variables: {
      ejTypeListInput: {
        projectId: { equals: projectId },
      },
    },
  })
  return (
    <Provider
      value={{
        records: data?.ejTypes?.records ?? [],
        refetch,
        fetching,
      }}
    >
      {children}
    </Provider>
  )
}
